import React, { useState } from 'react';

const Footer = ({ onSubscribeToNewsletters, onNotify }) => {
  const [email, setEmail] = useState("");

  const emailChangeHandler = (e) => {
    e.preventDefault();
    setEmail(e.target.value);
  }

  const newsLetterSubmitHandler = (e) => {
    e.preventDefault();

    if(email === "") {
      onNotify("Input a valid email address!");
    } else {
      onSubscribeToNewsletters(email);
    }
  }

  return (
    <footer className="bg-black pt-20 pb-20">
        <div className="max-w-[1500px] mx-auto lg:px-5">
          <div className="flex justify-center">
            <img src="img/Footer Image.png" alt="" />
          </div>

          <div className="max-w-[1000px] lg:max-w-[600px] mx-auto flex flex-col items-center text-center my-10">
            <div className="flex flex-col items-end">
              <p className="text-white text-2xl sm:text-3xl lg:text-4xl tracking-wider">DON'T MISS OUT ON ANYTHING!</p>
              <img src="img/Vector.png" alt="" />
            </div>

            <p className="text-[#B8B8B8] mt-3 font-light text-sm leading-loose">Subscribe to our mailing list to stay in the know about our services and gain access to up-to-date information on market trends, analysis, and performance metrics. </p>
          </div>

          <form onSubmit={newsLetterSubmitHandler} className="max-w-[600px] mx-auto px-5 flex justify-center gap-5">
            <input onChange={emailChangeHandler} type="email" name="email" placeholder="Enter your email address" className="px-4 h-[4rem] text-gray-200 placeholder:text-gray-200 w-full focus:outline-none bg-[#0D1011] font-light text-sm" />
            <input type="submit" name="submit" value="Join"
              className="text-white text-large font-semibold cursor-pointer py-[10px] px-[60px] bg-[#2CB8F2]" />
          </form>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 justify-center lg:text-left gap-20 pt-20 pb-10 border-b-2 border-zinc-900 px-10">

            <div className="text-white text-center">
              <p className="text-2xl font-semibold mb-4">Vent Africa</p>
              <p className="text-sm leading-tight font-extralight">251 Little Falls Drive, <br /> Wilmington DE, 19808.</p>
            </div>

            <div className="text-white">
              <p className="text-md font-light mb-3 lg:mb-5">Product Links</p>
              <ul className="flex flex-col gap-1 lg:gap-2 ml-8 lg:ml-0 list-disc lg:list-none">
                <li><a href="https://blog.vent.africa/" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">Blog</a></li>
                <li><a href="docs/AML POLICY FOR VENT AFRICA.pdf" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">AML/KYC & Compliance</a></li>
                <li><a href="docs/PRIVACY POLICY.pdf" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">Terms and Conditions</a></li>
                <li><a href="docs/Vent Terms of Use.pdf" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">Privacy Policy</a></li>
              </ul>
            </div>

            <div className="text-white">
              <p className="text-md font-light mb-3 lg:mb-5">Support Links</p>
              <ul className="flex flex-col gap-1 lg:gap-2 ml-8 lg:ml-0 list-disc lg:list-none">
                <li><a href="https://support.vent.africa/chat/1gobhlgk7" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">Help Center</a></li>
                <li><a href="https://support.vent.africa/chat/1gobhlgk7" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">Live Chat</a></li>
                <li><a href="https://t.me/ventafrica" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">Telegram Community</a></li>
              </ul>
            </div>

            <div className="text-white">
              <p className="text-md font-light mb-3 lg:mb-5">Communities</p>
              <ul className="flex flex-col gap-1 lg:gap-2 ml-8 lg:ml-0 list-disc lg:list-none">
                <li><a href="https://web.facebook.com/ventafricahq" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">Facebook</a></li>
                <li><a href="https://www.linkedin.com/company/vent-africa/" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">LinkedIn</a></li>
                <li><a href="https://twitter.com/ventafricaHQ" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">Twitter</a></li>
                <li><a href="https://instagram.com/ventafrica" target='_blank' rel="noopener noreferrer" className="text-sm font-extralight">Instagram</a></li>
              </ul>
            </div>
          </div>
        </div>
    </footer>
  )
}

export default Footer;